import { Directive, Input, inject } from '@angular/core';
import { AbstractControl, NG_ASYNC_VALIDATORS, ValidationErrors, Validator } from '@angular/forms';
import { NetzbetreiberService } from '../../service/netzbetreiber/netzbetreiber.service';
import { map } from 'rxjs/operators';
import { Observable, of } from 'rxjs';
import { UniqueTeilgebietAndNetzbetreibernummer } from '../../domain/model/netzbetreiber';

@Directive(
    {
        selector: '[tnbUniqueTeilgebietAndNetzbetreibernummer]',
        providers: [
            {
                provide: NG_ASYNC_VALIDATORS,
                useExisting: UniqueTeilgebietAndNetzbetreibernummerDirective,
                multi: true,
            },
        ],
        standalone: false,
    },
)
export class UniqueTeilgebietAndNetzbetreibernummerDirective<T extends AbstractControl<UniqueTeilgebietAndNetzbetreibernummer>> implements Validator {
    private netzbetreiberService = inject(NetzbetreiberService);

    @Input('tnbUniqueTeilgebietAndNetzbetreibernummer') config: {
        originalNetzbetreiberValues: UniqueTeilgebietAndNetzbetreibernummer,
        enabled: boolean
    };

    validate(formGroup: T): Observable<ValidationErrors | null> | ValidationErrors {
        {
            if (!this.config?.enabled) {
                return of(null);
            }

            if (!formGroup.value || !this.config?.originalNetzbetreiberValues) {
                return of(null);
            }

            if (
                this.config?.originalNetzbetreiberValues.teilgebiet === formGroup.value.teilgebiet &&
                this.config?.originalNetzbetreiberValues.netzbetreibernummer === formGroup.value.netzbetreibernummer
            ) {
                return of(null);
            }

            return this.netzbetreiberService.getAlleUniqueTeilgebietAndNetzbetreibernummer(formGroup.getRawValue())
                .pipe(
                    map(nb => {
                        return (nb.length > 0)
                            ? { 'uniqueTeilgebietName': true }
                            : null;
                    }),
                );
        }
    }
}
